import type { PermissionKey } from './permissions';
import { permissionsCopy } from '../copy/permissions';

// ---------------------------------------------------------------------------
// Pages that need one tenant permission as a whole, beside lib/planGates'
// plan table. The nav hides them from someone an admin set to No, and a
// direct URL shows a plain "no access" card rather than the page half-loading
// with refusals. Only pages where the page IS the permission belong here;
// admin-only permissions (billing, users, webhooks, prompts) aren't listed
// because their pages are admin-only already and admins are never restricted
// on the client.
// ---------------------------------------------------------------------------

export interface RoutePermission {
  /** The route and everything under it. */
  path: string;
  permission: PermissionKey;
  /** What the page says instead, e.g. "Your administrator hasn't given you access to reports." */
  noAccess: string;
  /** Where to go instead, when the page has a part they can open (Insights → Reflections). */
  fallback?: string;
}

// Insights' report tabs; its Reflections tab is open to everyone, so the
// page itself isn't listed, and a report tab (the weekly email links Summary)
// opens Reflections for someone without reports.
export const ROUTE_PERMISSIONS: readonly RoutePermission[] = ['summary', 'time', 'drivers', 'activity'].map(tab => ({
  path: `/insights/${tab}`, permission: 'canViewReports' as PermissionKey, noAccess: permissionsCopy.noAccess.reports,
  fallback: '/insights/reflections',
}));

export function routePermissionFor(pathname: string): RoutePermission | undefined {
  const path = pathname.toLowerCase();
  return ROUTE_PERMISSIONS.find(g => path === g.path || path.startsWith(`${g.path}/`));
}
